/* global webpack */

import angular from 'angular'

import { toUrl } from '../utils/security'
import { property } from 'lodash-es'

import StrictObj from '../utils/strict-obj'
import debugFields from '../utils/debug-fields'

const GET_BOOTSTRAP_DATA = 'getBootstrapData'
const GET_TOP_POSTS = 'getTopPosts'
const GET_BELOW_POSTS = 'getBelowPosts'
const GET_ABOVE_POSTS = 'getAbovePosts'

angular
  .module('ggs.rpc')
  .factory('galleryRpc', GalleryRpcProvider)

function GalleryRpcProvider(
  $http,
  $log,
  $sce,
  Retry,
  debugObj,
  DebugRequest) {

  const sign = 'galleryRpc'
  const debugRequest = DebugRequest(sign)

  let apiHost = webpack.apiServerHost
  const getRetryDelay = 5e3
  const getRetryLimit = 5

  const jsonp = (url, params) =>
    $http.jsonp($sce.trustAsResourceUrl(url), { params }).then(property('data'))

  const HostSwappingErrorHandler = (methodName) =>
    (err, retryDesc, willRetry) => {
      if (willRetry && webpack.apiServerHost !== webpack.apiProdHost) {
        apiHost =
          apiHost === webpack.apiProdHost
            ? webpack.apiServerHost
            : webpack.apiProdHost
        $log.warn(`${sign}#${methodName}:`, retryDesc, 'Additionally trying to swap the server host!', err)
      } else {
        $log.warn(`${sign}#${methodName}:`, retryDesc, err)
      }
    }

  const SimpleErrorHandler = (methodName) =>
    (err, retryDesc) =>
      $log.warn(`${sign}#${methodName}:`, retryDesc, err)

  // getBootstrapData
  const fmtBootstrapDataUrl = (galleryKey) =>
    toUrl(apiHost + '/galleries/' + galleryKey + '/bootstrap')

  const getBootstrapData =
    Retry(
      getRetryDelay,
      getRetryLimit,
      debugRequest(GET_BOOTSTRAP_DATA, (galleryKey, sort, sharedPostKey) =>
        jsonp(fmtBootstrapDataUrl(galleryKey), {
          t: Date.now(),
          d: sharedPostKey,
          sort
        })),
      HostSwappingErrorHandler(GET_BOOTSTRAP_DATA))

  // getTopPosts
  const fmtMorePostsUrl = (galleryKey) =>
    toUrl(apiHost + '/galleries/' + galleryKey + '/more')

  const getTopPosts =
    Retry(
      getRetryDelay,
      getRetryLimit,
      debugRequest(GET_TOP_POSTS, (galleryKey, sort, modulus, maxId, limit) =>
        jsonp(fmtMorePostsUrl(galleryKey), {
          t: Date.now(),
          sort,
          modulus,
          max_id: maxId,
          limit
        })),
      SimpleErrorHandler(GET_TOP_POSTS))

  // getBelowPosts
  const getBelowPosts =
    Retry(
      getRetryDelay,
      getRetryLimit,
      debugRequest(GET_BELOW_POSTS, (galleryKey, sort, modulus, maxId, skip, limit) =>
        jsonp(fmtMorePostsUrl(galleryKey), {
          t: Date.now(),
          sort,
          modulus,
          max_id: maxId,
          skip,
          limit
        })),
      SimpleErrorHandler(GET_BELOW_POSTS))

  // getAbovePosts
  const fmtRecentPostsUrl = (galleryKey) =>
    toUrl(apiHost + '/galleries/' + galleryKey + '/recent')

  const getAbovePosts =
    Retry(
      getRetryDelay,
      getRetryLimit,
      debugRequest(GET_ABOVE_POSTS, (galleryKey, sort, maxId, limit) =>
        jsonp(fmtRecentPostsUrl(galleryKey), {
          t: Date.now(),
          sort,
          max_id: maxId,
          limit
        })),
      SimpleErrorHandler(GET_ABOVE_POSTS))

  // export
  return debugObj('galleryRpc', StrictObj(debugFields({
    getTopPosts,
    getBelowPosts,
    getAbovePosts,
    getBootstrapData
  }, {
    _apiHost: () => apiHost
  })))
}
